const state = {
  drawer: true,
  gradient: 'rgba(0, 0, 0, .7), rgba(0, 0, 0, .7)',
  items: [],
  isDataLoaded: false,
}

const getters = {
  getDrawer: state => state.drawer,
  setItems: state => state.items,
  titles(state) {
    function findAll(items, childlist = []) {
      items.forEach(item => {
        if (item.children) {
          findAll(item.children, childlist);
        } else {
          childlist.push(item);
        }
      });
      return childlist;
    }
    return findAll(state.items);
  }
}

const mutations = {
  setDrawer (state, data) {
    state.drawer = data
  },
  setItems(state, items) {
    state.items = items;
  },
  resetDataLoadState(state) {
    state.isDataLoaded = false;
  },
  setIsDataLoaded(state, isLoaded) {
    state.isDataLoaded = isLoaded;
  },
}

const actions = {
  toggleDrawer ({ commit }, value) {
    commit('setDrawer', value)
  },
  async fetchList({ commit, state, rootState }) {
    if (state.isDataLoaded) {
      console.log('state.isDataLoaded');
      return;
    }
    commit('setIsDataLoaded', false);
    state.isDataLoaded = false;
  
    const apiPreUrl = rootState.url.apiPreUrl;
    const user = JSON.parse(sessionStorage.getItem('user'));
    if (!user || !user.token) {         
      return;
    }
    const token = user.token;
    try {
      const response = await axios({
        method: 'POST',
        url: apiPreUrl + '/api/v1.0/navi',
        headers: { Authorization: `Bearer ${token}` }
      });
  
      const language = rootState.language.selectedLanguage;
      if (!rootState.language.translations[language]) {

        const updateItems = (items) => {
          items.forEach((item) => {
            if (item.title && rootState.language.translations[item.title]) {
              item.title = rootState.language.translations[item.title];
            }
            if (item.children) {
              updateItems(item.children);
            }
          });
        };
      
        updateItems(response.data);
        commit('setItems', response.data);
      
        state.isDataLoaded = true;
        commit('setIsDataLoaded', true);
      }
    } catch (error) {
      console.error('error', error);
    }
  },
  
  resetDataLoadState({ commit }) {
    commit('resetDataLoadState');
  }
}
import axios from "axios";
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
